const raw = (param) => {
    return param;
}

module.exports = raw